import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import searchSlice from "./searchSlice";
import onboardSlice from './onboardSlice'
import mobileVerificationSlice from './mobileVerificationSlice'
import {
  persistReducer,
  persistStore,
} from "redux-persist";
import collegeSlice from './collegeDetailsSlice'
import userSlice from './userSlice'
import recommendSlice from './recommendSlice'
import shortlistSlice from './shortlistSlice'
import courseSlice from './courseDetailsSlice'
import profileSlice from './profileSlice'
import authReducer from './slices/authSlice'
import errorReducer from './errorSlice'; 
import compareReducer from './compareSlice';
import upgradeReducer from './upgradeSlice';

const persistConfig = {
  key: "app-futurx",
  storage,
};

const rootReducer = combineReducers({
  searchData: searchSlice,
  collegeDetails: collegeSlice,
  onboardData: onboardSlice,
  mobileVerificationData: mobileVerificationSlice,
  userData: userSlice,
  recommedData: recommendSlice,
  shortlistData: shortlistSlice,
  course: courseSlice,
  profileData: profileSlice,
  auth: authReducer,
  error: errorReducer,
  compare: compareReducer,
  upgrade: upgradeReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);
